import React, {useEffect, useState} from 'react';
import {WorkflowDiagramNodes} from './WorkflowNodes';
import {Flow, FlowFetchResponse} from '../../_services/Flow';

export interface WorkflowDiagramProps {
    workflowId: number;
    entryId?: number;
}

const nodes = [
    {type: 'node', name: 'Initiate New Request', hasNext: true, status: 'complete'},
    {
        type: 'group',
        hasNext: true,
        nodeGroups: [
            [
                {type: 'node', name: 'Manager Approval', hasNext: true, status: 'complete'},
                {type: 'node', name: 'Sales Approval', hasNext: true, status: 'active'},
                {type: 'node', name: 'TOA Approval', hasNext: true, status: 'pending'},
                {type: 'node', name: 'Finance Approval', hasNext: false, status: 'pending'},
            ],
            [
                {type: 'node', name: 'DSM Approval', hasNext: true, status: 'not-used'},
                {type: 'node', name: 'RVP Approval', hasNext: true, status: 'not-used'},
                {type: 'node', name: 'TOA Approval', hasNext: false, status: 'not-used'},
            ],
        ],
    },
    {type: 'node', name: 'Complete', hasNext: false, status: 'pending'}
];

export const WorkflowDiagram: React.FunctionComponent<WorkflowDiagramProps> = ({
                                                                                   workflowId,
                                                                                   entryId
                                                                               }) => {
    const [showWorkflowDiagram, setShowWorkflowDiagram] = useState<boolean>(false);
    const [workflowDiagram, setWorkflowDiagram] = useState<any>([]);

    useEffect(() => {
        Flow.getInstance().getWorkflowDiagram(workflowId, entryId)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setWorkflowDiagram(response.json);
                }
            })
            .catch((error: any) => {
            })
            .finally(() => {

            });
    }, [workflowId, entryId]);

    return (
        <>
            {workflowDiagram && workflowDiagram.length > 0 &&
            <>
                {showWorkflowDiagram ?
                    <div className="mb-3 workflow-diagram">
                        <div className="pl-2 pr-2">
                            <WorkflowDiagramNodes nodes={workflowDiagram}/>
                        </div>
                    </div>
                    :
                    <div className={'pr-2'}>
                        <button type="button"
                                className="btn btn-sm btn-link"
                                onClick={() => setShowWorkflowDiagram(true)}
                        >Workflow Diagram
                        </button>
                    </div>
                }
            </>
            }
        </>
    );
}
;